import "./CoolDivider.css";

function CoolDivider() {
  return <div className="divider"></div>;
}

export default CoolDivider;
